import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {EntityCreatingCard} from '../index';

import {LocalDomainEditForm} from '../../containers/index';

function LocalDomainCreating(props) {
  const {
    handleClickButtonCancel,
    handleClickButtonSave,
    isValidLocalDomainInfo,
  } = props;

  return (
    <EntityCreatingCard
      title={I18n.t('campusPage.localDomainsTab.createLocalDomain')}
      handleClickButtonCancel={handleClickButtonCancel}
      handleClickButtonSave={handleClickButtonSave}
      isValidEntity={isValidLocalDomainInfo}
      customCardClass="card_localDomains"
      customCardContentClass="card__content_localDomains"
      content={
        <LocalDomainEditForm />
      }
    />
  );
}

LocalDomainCreating.propTypes = {
  handleClickButtonCancel: PropTypes.func.isRequired,
  handleClickButtonSave: PropTypes.func.isRequired,
  isValidLocalDomainInfo: PropTypes.bool.isRequired,
};

export default LocalDomainCreating;
